module.exports = __webpack_public_path__ + "img/login_icon.18e94ade.png";